//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'

export default {
  props: {
    broadAddress: {
      default: () => { }
    },
  },
  data () {
    /**
     * @method validatorEffect 生效日期為指定時，必須選擇
     */
    let validatorEffect = (rule, value, callback, text) => {
      if (this.form.effectiveTimeType == '2' && !value) {
        callback(new Error(text))
      } else callback()
    }
    return {
      isGetInstallDate: false,    // 是否获取了安装日期
      installTotalAddress: '',
      timelist: [ //信息推廣
        {
          name: '安裝完成豎日',
          value: '1',
        }, {
          name: '指定日期',
          value: '2',
        }
      ],
      billTypeList: [ //賬單方式
        {
          name: 'Contract base bill',
          value: '1',
        }, {
          name: 'Payment on bill',
          value: '2',
        }
      ],
      contractLanguageData: [ // 合約語言
        {
          name: "中文",
          value: "1"
        },
        {
          name: "英文",
          value: "2"
        }
      ],
      infomorelist: [ //信息推廣
        {
          name: '接受中國香港移動推廣信息',
          value: '1',
        }, {
          name: '接收非中國香港移動推廣信息',
          value: '2',
        }
      ],
      rules: {
        installDate: [
          { required: true, message: '請選擇安裝日期', trigger: 'blur' }
        ],
        installDate: [
          { required: true, message: '請選擇安裝時間', trigger: 'blur' }
        ],
        effectDate: [{
          required: true,
          validator: (rule, value, callback) => validatorEffect(rule, value, callback, '請選擇指定生效日期'),
          trigger: 'blur'
        }],
      },
      form: {
        remark: '',
        installDate: '',
        installTime: '',
        effectiveTimeType: '1', // 生效日期類型
        billType: '1', // 賬單方式
        contractLanguage: '1', // 合約語言1.中文繁体，2.英文
        effectDate: '', // 生效日期
        accpetInfo: ['1'],
        autoRenew: '2' // 自动续约 1:是，2否
      },
      data: {
        installTime: [],
      },
      pickerInstallOptions: {
        disabledDate: time => time.getTime() < Date.now()
      },
      pickerEffectOptions: {
        disabledDate: time => time.getTime() < Date.now()
      }
    }
  },
  created () {
    this.installTotalAddress = this.broadAddress.installAddress + '樓層（' + this.broadAddress.floor + '）' + '單位（' + this.broadAddress.flat + '）'; //完整地址
    //   this.getInstallDate();
  },
  methods: {
    installTimeFocus () {  // 安裝時間focus
      if (!this.form.installDate) {
        this.$message({
          customClass: this.$device,
          showClose: false,
          message: '請先選擇安裝日期',
          type: 'warning'
        })
        this.data.installTime = [];
      }
    },
    handTimeChange (val) { // 生效日期選項
      if (val == '2') {
        if (!this.form.installDate) {
          this.$message({
            customClass: this.$device,
            showClose: false,
            message: '請先選擇安裝日期',
            type: 'warning'
          });
          return this.form.effectiveTimeType = '1';
        }
        let _startDate = new Date(this.form.installDate);
        _startDate.setDate(new Date(this.form.installDate).getDate() + 1);
        let _endDate = new Date(this.form.installDate);
        _endDate.setDate(new Date(this.form.installDate).getDate() + 365);
        console.log(this.form.installDate, _endDate, _startDate, 201);
        // this.pickerEffectOptions.disabledDate = function(time) {
        //   if(time.getTime() < Date.now()) return true;
        //   if(time.getTime() < _startDate.getTime()) return true;
        //   if(time.getTime() > _endDate.getTime()) return true;
        // }
        this.pickerEffectOptions = {
          disabledDate (time) {
            if (time.getTime() < Date.now()) return true;
            if (time.getTime() < (_startDate.getTime() - 43200000)) return true;
            if (time.getTime() > _endDate.getTime()) return true;
          }
        }
        this.$nextTick(() => this.$refs.effectDatePicker.focus());
      }
    },
    installDateChange (val) { // 選擇安裝日期
      this.form.effectiveTimeType = '1'
      this.form.installTime = ''
      this.data.installTime = [];
      this.getInstallTime();
    },
    async getInstallDate (effectDate) { //獲取可安裝日期(根据有效日期effectDate计算)
      var date = new Date(effectDate);
      date = new Date(date.setDate(date.getDate() + 2));    // 加两天
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = String(month).padStart(2, '0');
      let days = date.getDate();
      days = String(days).padStart(2, '0');
      let newdate = year + '-' + month + '-' + days;
      this.isGetInstallDate = true;
      return this.$http('broadband/getQuotaAvailable', {
        addressCode: this.broadAddress.addressCode,
        floor: this.broadAddress.floor,
        flag: this.broadAddress.flat,
        provisionDate: newdate, // 激活日期
        vendorType: this.broadAddress.vendorType
      }).then(res => {
        if (res.returnCode == '1000' && res.dataInfo) {
          let _allowedMonthDay = res.dataInfo;
          this.pickerInstallOptions.disabledDate = function (time) {
            let isDisabledTime = true;
            if (time.getTime() < Date.now()) return isDisabledTime;
            for (let item of _allowedMonthDay) {
              if (Math.abs(time.getTime() - new Date(item).getTime()) < 43200000) { // 12個小時差
                isDisabledTime = false;
                break;
              }
            }
            return isDisabledTime;
          }
        }
      })
    },
    async getInstallTime () { //獲取可安裝日期具體時間
      return this.$http('broadband/getQuotaAvailableTime', {
        addressCode: this.broadAddress.addressCode,
        floor: this.broadAddress.floor,
        flag: this.broadAddress.flat,
        provisionDate: this.form.installDate, //選擇的日期
        vendorType: this.broadAddress.vendorType
      }).then(res => {
        if (res.returnCode == '1000' && res.dataInfo) {
          let newArr = [];
          let data = res.dataInfo;
          for (var i = 0; i < data.length; i++) {
            if (data[i].indexOf(this.form.installDate) != -1) {
              newArr.push({
                name: data[i],
                value: data[i]
              })
            }
          };
          this.data.installTime = newArr;
        }
      })
    },
    toPosition (dom, offsetValue = 100) {
      let {
        offsetTop
      } = dom
      window.scroll(0, offsetTop - offsetValue)
    },
    submitForm () {
      let _temp;
      this.$refs['dateForm'].validate(async (valid, object) => {
        if (valid) return _temp = true;
        else {
          let target = null;
          for (let i in object) {
            if (this.$refs[i]) {
              target = i
              break;
            }
          }
          let dom = this.$refs[target].$el
          this.toPosition(dom)
          return _temp = false;
        }
      });
      return _temp
    },
    getForm () {
      let _temp = Object.assign({}, this.form);
      if (_temp.effectiveTimeType == '1') {  // 安裝完成豎日
        let effectDate = new Date(_temp.installDate).getTime();
        _temp.effectDate = effectDate + 86400000;
      } else if (_temp.effectiveTimeType == '2') { // 指定日期
        let appointHandTime = _temp.effectDate.substr(0, 4) + '/' + _temp.effectDate.substr(5, 2) + '/' + _temp.effectDate.substr(8, 2);
        _temp.effectDate = new Date(appointHandTime).getTime();
      };
      if (_temp.accpetInfo.length > 1) {
        _temp.accpetInfo = '3'
      } else {
        _temp.accpetInfo = _temp.accpetInfo[0]
      }
      _temp.installAddress = this.installTotalAddress;
      delete _temp.effectiveTimeType
      return _temp;
    }
  },
  computed: {


  },
  components: {

  }
};
